module.exports = __webpack_public_path__ + "media/DownloadIOSAppVi.816ec4c8.svg";